// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"78cfc844","635":"f8f18cf5"}[chunkId] + ".chunk.js";
};